import { devices } from '../../constants';

/**
 * Is the device a small device?
 * An IPad is not a small device
 * A window.width > 767 is not a small device
 * A window.width <= 767 is a small device
 * @return {Boolean} true if it is a small device, false otherwise
*/
export const isSmallDevice = function () {
    // is it an Apple iPad or iPhone?
    if (isiPad()) {
        // not a small device
        return false;
    }
    // Number of pixels to change to small device display
    const smallDeviceWidth = devices.sizes.SMALL;
    // Check device width
    return window.innerWidth <= smallDeviceWidth;
};

/**
 * Is the device a mobile device?
 * @return {Boolean} true if it is a mobile device, false otherwise
 */
export const isMobileDevice = function () {
    return /Android|webOS|BlackBerry|IEMobile|Opera Mini/i.test(window.navigator.userAgent) || isIos();
};

/**
 * Detect iOS 13+
 * @return {Boolean} true if browser is iOS 13+, false otherwise
 */
const isIos = function () {
    return [
        'iPad Simulator',
        'iPhone Simulator',
        'iPod Simulator',
        'iPad',
        'iPhone',
        'iPod'
    ].includes(navigator.platform)
        // iPad on iOS 13 detection
        || (navigator.userAgent.includes('Mac') && 'ontouchend' in document);
};

/**
 * Is the device an iPhone?
 * @return {Boolean} true if it is an iPhone, false otherwise
 */
export const isiPhone = function () {
    return /iPhone/i.test(window.navigator.userAgent);
};

/**
 * Is the device an iPad?
 * Useragent FireFox on iPad: Macintosh + FxiOS
 * Useragent FireFox on iPad mini: Macintosh + Safari,
 * Useragent FireFox on iPhone: iPhone
 * @return {Boolean} true if it is an iPad, false otherwise
 */
export const isiPad = function () {
    const userAgent = window.navigator.userAgent;
    return /iPad/i.test(userAgent) || /Macintosh/i.test(userAgent);
};

/**
 * If it is an iPad, is browser Safari used?
 * @return {Boolean} true if it is an iPad using Safari, false otherwise
 */
export const isiPadSafari = function () {
    const userAgent = window.navigator.userAgent;
    return (!!userAgent.match(/iPad/i) ||                                     // Detect iPad first.
        !!userAgent.match(/Macintosh/i)) &&                               // Filter iPad in case of FireFox
        !!userAgent.match(/WebKit/i) && 	                              // Filter browsers with webkit engine only
        !userAgent.match(/CriOS/i) &&		                              // Eliminate Chrome & Brave
        !userAgent.match(/Chrome/i) &&		                              // Eliminate Chrome on Android
        !userAgent.match(/OPiOS/i) &&		                              // Rule out Opera
        !userAgent.match(/FxiOS/i) &&		                              // Rule out Firefox
        !userAgent.match(/Firefox/i) &&		                              // Rule out Firefox on Android
        !(userAgent.match(/Macintosh/i) && userAgent.match(/Safari/i)) && // Rule out Firefox on older iOS
        !userAgent.match(/FocusiOS/i);		                              // Eliminate Firefox Focus as well!
};

/**
 * Does the mobile browser supports geolocation?
 * @return {Boolean} true if geolocation is supported, false otherwise
 */
export const hasGeoLocation = function () {
    return !!window.navigator.geolocation;
};

/**
 * Detect Internet Explorer
 * @return {Boolean} true if browser is Internet Explorer, false otherwise
 */
export const isIE = function () {
    const userAgent = window.navigator.userAgent;
    return /msie/i.test(userAgent) || /trident/i.test(userAgent);
};
